export default __webpack_public_path__ + "static/media/team.b35a8b01.jpg";